export default "__VITE_ASSET__CfXARYkL__"